import { Layouts } from 'react-grid-layout';
import PortfolioStatus from '../../components/portfolio/PortfolioStatus';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    md: [
        {
            h: 17,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    xs: [
        {
            h: 17,
            static: true,
            w: 24,
            x: 0,
            y: 3,
            i: 'c2',
        },
        {
            h: 3,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {
        date: 'today',
    },
    components: [
        {
            key: 'c1',
            name: 'page-header',
            props: {
                header: {
                    title: 'ui.mm.sub-menu-portfolio-status',
                    path: '',
                },
                rhsComponents: [
                    {
                        name: 'date-picker',
                        props: {
                            defaultPeriod: '1Y',
                        },
                    },
                ],
            },
        },
        {
            name: 'canopy-table',
            key: 'c2',
            apiDetails: {
                endpoint: `portfolio/timeliness_summary?`,
                endpointParams: {
                    to_date: '*,date',
                    parent_user_ids: '*,user_id',
                },
            },
            props: {
                requiredQueryFields: ['parent_user_ids', 'to_date'],
                clientSideSearch: true,
                clientSideSort: true,
                clientSideSortParentRows: true,
                title: '',
                showDownloadOn: ['desktop', 'tablet'],
                downloadCurrentData: false,
                showPagination: false,
                CustomFooter: <PortfolioStatus />,
                columns: [
                    {
                        key: 'child_display_name',
                        type: 'text',
                        width: 200,
                        canSort: true,
                        headerText: 'ui.mm.table-headers.child-display-name',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                    },
                    {
                        key: 'latest_price_date',
                        type: 'portfolioStatusDate',
                        headerText: 'ui.mm.table-headers.latest-price-date',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        canSort: true,
                        toDateFormat: 'DD MMM YYYY',
                        otherKeys: ['data_source'],
                        popoverText: 'portfolio-status.latest-price-date',
                    },

                    {
                        key: 'oldest_price_date',
                        type: 'portfolioStatusDate',
                        headerText: 'ui.mm.table-headers.oldest-price-date',
                        selectedByDefaultOn: ['desktop'],
                        toDateFormat: 'DD MMM YYYY',
                        canSort: true,
                        otherKeys: ['data_source'],
                        popoverText: 'portfolio-status.oldest-price-date',
                    },
                    {
                        key: 'latest_transaction_date',
                        type: 'portfolioStatusDate',
                        headerText:
                            'ui.mm.table-headers.latest-transaction-date',
                        selectedByDefaultOn: ['desktop'],
                        toDateFormat: 'DD MMM YYYY',
                        canSort: true,
                        otherKeys: ['data_source'],
                        popoverText: 'portfolio-status.latest-transaction-date',
                    },
                    {
                        key: 'latest_source_as_of',
                        type: 'portfolioStatusDate',
                        headerText:
                            'ui.mm.table-headers.latest-source-as-of-date',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        toDateFormat: 'DD MMM YYYY',
                        canSort: true,
                        otherKeys: ['data_source'],
                        popoverText:
                            'portfolio-status.latest-source-as-of-date',
                    },
                ],
                ga_event_name: 'Portfolio Status',
            },
        },
    ],
};
